import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'common/store';
import type { UseStoreValues } from 'common/types/store';
import { WORKBOARD_CURRENT_VALUATIONS_URL } from 'dashboard409a/common/config/urls';
import { getPreviousWorkboardRoute } from 'dashboard409a/utilities/navigation';

const WorkboardIndexRedirect = () => {
  const navigate = useNavigate();
  const [{ user }] = useStore() as UseStoreValues;
  const userId = user?.id;

  useLayoutEffect(() => {
    if (!userId) {
      return;
    }

    navigate(getPreviousWorkboardRoute(userId) || WORKBOARD_CURRENT_VALUATIONS_URL, { replace: true });
  }, [navigate, userId]);
  return null;
};

export default WorkboardIndexRedirect;
